module.exports = __webpack_public_path__ + "static/media/service-dummy.3aecd82c.svg";